export const INITIAL_WIDTH = 100;
